import React from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';
import { EditableContent } from './EditableContent';

interface MemberAdvantageProps {
  icon: LucideIcon;
  title: string;
  description: string;
  index: number;
}

const MemberAdvantageCard: React.FC<MemberAdvantageProps> = ({ icon: Icon, title, description, index }) => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-6 hover:transform hover:scale-105 transition-all duration-300">
      <div className="flex flex-col items-center text-center mb-4">
        <div className="bg-dark text-beige p-4 rounded-full mb-4">
          <Icon className="h-8 w-8" />
        </div>
        <h3 className="text-xl font-bold text-dark mb-3">
          <EditableContent
            section="advantages"
            contentKey={`advantage-${index}-title`}
            defaultValue={title}
          />
        </h3>
      </div>
      <div className="text-dark/80 text-center">
        <EditableContent
          section="advantages"
          contentKey={`advantage-${index}-description`}
          defaultValue={description}
          type="textarea"
        />
      </div>
    </div>
  );
};

export default MemberAdvantageCard;